module.exports = __webpack_public_path__ + "img/ca-icon.e8e244b8.png";